<template>
  <div>
    <h2 class="text-h6">Organisation logo</h2>
    <h3 class="h4 subtitle mb-4">Add a public url to your to logo, to include this in the email.</h3>
    <div class="block">
      <c-input
        :value.sync="$v.logoUrl.$model"
        :lazy="false"
        class="input"
        type="text"
        placeholder="https://your-url.com/images/logo.png"
        :is-valid="checkIfValid('logoUrl')"
        invalid-feedback="Please enter a logo url"
        @keydown="allowSave"
      />
    </div>
    <c-button-group>
      <c-button :disabled="!isValid" color="primary" @click="save">
        <c-spinner v-if="isSaving" color="success" size="sm" />
        <span v-else>Save logo url</span>
      </c-button>
      <c-button v-if="showCancelButton" color="secondary" :disabled="isSaving" @click="cancelEdit">Cancel</c-button>
    </c-button-group>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, url } from 'vuelidate/lib/validators';
import _ from 'lodash';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'OrganisationLogo',
  components: {},
  mixins: [validationMixin],
  props: {
    organisation: Object,
  },
  data() {
    return {
      error: null,
      isSaving: false,
      success: false,
      showCancelButton: false,
      enableSave: false,
      logoUrl: null,
      requiredFields: {
        logoUrl: false,
      },
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this, null, 4);
    },
    isValid() {
      return !this.$v.$invalid;
    },
    isDirty() {
      return this.$v.$anyDirty;
    },
  },
  mounted() {
    this.setData();
  },
  validations: {
    logoUrl: {
      required,
      url,
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === '');
    },
    setData() {
      this.logoUrl = _.get(this.organisation, 'config.email.externalLogoUrl');
      this.$v.$reset();
    },
    cancelEdit() {
      this.setData();
      this.resetButtonState();
    },
    resetButtonState() {
      this.showCancelButton = false;
      this.enableSave = false;
    },
    allowSave() {
      this.showCancelButton = true;
      this.enableSave = true;
    },
    save() {
      this.$v.$touch();
      if (!this.isValid) {
        return;
      }
      this.isSaving = true;
      this.error = null;
      const data = {
        id: this.organisation._id,
        logoUrl: this.logoUrl,
      };
      this.$http
        .post(buildEndpoint('organisation-admin/organisation/email/update-logo-url'), data)
        .then((response) => {
          this.isSaving = false;
          if (response.data.success) {
            _.set(this.organisation, 'config.email.externalLogoUrl', this.logoUrl);
            this.resetButtonState();
            this.$store.commit('addSuccessMessage', {
              header: 'Success',
              message: 'Logo URL updated',
            });
            this.$v.$reset();
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error updating logo URL',
              message: response.data.error,
            });
          }
        })
        .catch((error) => {
          this.isSaving = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error updating logo URL',
            message: error,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped=""></style>
